import React from "react";
import { useState } from "react";

import { Trans, useTranslation } from "react-i18next";
import toast from "react-hot-toast";
import {
  Badge,
  CircularProgress,
  IconButton,
  Tooltip
  // Typography
} from "@mui/material";
import { TextField, Button } from "@mui/material";
import { Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import AttachmentIcon from "@mui/icons-material/Attachment";
// import CancelIcon from "@mui/icons-material/Cancel";

import useStyles from "./Suppot.style";
import { createSubjectStart } from "../../redux-saga/redux/support/chatsupport";
import {
  ACCEPTED_IMAGE_FORMATS,
  MAX_IMAGE_FILE_SIZE_SUPPORT
} from "../../utils/constants";

const CreatNew = () => {
  const { t } = useTranslation();
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [supportImage, setSupportImage] = useState({
    selectedImage: null,
    selectedImageName: "",
    avatar: null
  });
  const classes = useStyles();
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.supportmodal.loading);

  const handleSetSubject = (e) => {
    if (e.target.value !== " ") {
      const input = e.target.value;

      if (input.length <= 50) {
        setSubject(input);
      }
    }
  };

  const handleSetMessage = (e) => {
    if (e.target.value !== " ") {
      setMessage(e.target.value);
    }
  };

  const messageSentSuccess = (e) => {
    e.preventDefault();
    const validation = [];
    const formData = new FormData();

    if (subject.length === 0) {
      validation.push(t("SUPPORT_MODAL.EMPTY_SUBJECT"));
    }
    if (message.length === 0) {
      validation.push(t("SUPPORT_MODAL.EMPTY_MESSAGE"));
    }
    if (validation.length !== 0) {
      validation.forEach((message) => {
        toast.error(message, { id: message });
      });
    }

    if (supportImage.selectedImage) {
      formData.append("attachment", supportImage.selectedImage);
    }
    if (subject.trim().length !== 0 && message.trim().length !== 0) {
      formData.append("subject", subject);
      formData.append("message", message);
      dispatch(createSubjectStart(formData));
      setSubject("");
      setMessage("");
      setSupportImage({
        selectedImage: null,
        avatar: null,
        selectedImageName: ""
      });
    }
  };

  const resetSelectedImage = () => {
    setSupportImage({
      selectedImage: null,
      selectedImageName: "",
      avatar: null
    });
  };

  const handleFileInputChange = (event) => {
    event.preventDefault();
    const file = event.target.files && event.target.files[0];
    if (!file) {
      resetSelectedImage();
      return;
    }

    if (file?.size > MAX_IMAGE_FILE_SIZE_SUPPORT) {
      toast.error(t("MYPROFILE.MAX_FILE_SIZE_ERROR_2MB"), {
        id: "MAX_FILE_SIZE_ERROR"
      });
      return;
    }
    setSupportImage((current) => ({
      selectedImage: file,
      avatar: current.avatar,
      selectedImageName: file?.name || ""
    }));
  };

  // const makeAvatarUrl = () => {
  //   if (supportImage.selectedImage) {
  //     return URL.createObjectURL(supportImage.selectedImage);
  //   }
  //   return "/images/user_icon.svg";
  // };

  return (
    <>
      <Grid className={classes.formWrap}>
        <p className={classes.newqueryStyle}>
          {" "}
          {t("SUPPORT_MODAL.CREATE_NEW")}
        </p>
        <TextField
          className={classes.inputgroup}
          onChange={handleSetSubject}
          disabled={loading}
          value={subject}
          type="text"
          placeholder="subject"
          label={t("SUPPORT_MODAL.TICKETNAME_LABEL")}
          variant="outlined"
          id="subject-field"
        />
        <Grid className={classes.messageWrap}>
          <p className={classes.titleDetails}>
            {" "}
            <Trans components={{ b: <b /> }}>
              {t("SUPPORT_MODAL.TITLE_DETAILS")}
            </Trans>
          </p>{" "}
          <TextField
            disabled={loading}
            className={classes.messagegroup}
            onChange={handleSetMessage}
            value={message}
            placeholder="message"
            label={t("SUPPORT_MODAL.TICKETMESSAGE_LABEL")}
            multiline
            rows={4}
            variant="outlined"
            id="message-field"
            InputProps={{
              endAdornment: (
                <Grid className={classes.fileAttachBtn}>
                  <Badge
                  // badgeContent={
                  //   supportImage.selectedImage ? (
                  //     <IconButton onClick={resetSelectedImage}>
                  //       <CancelIcon />
                  //     </IconButton>
                  //   ) : null
                  // }
                  >
                    <Tooltip
                      classes={{
                        tooltip: classes.toolTipWrap,
                        arrow: classes.toolTipArrow
                      }}
                      title={
                        supportImage.selectedImage
                          ? t("SUPPORT_MODAL.CHANGE_IMAGE")
                          : t("SUPPORT_MODAL.UPLOAD_IMAGE")
                      }
                      arrow
                    >
                      <IconButton
                        className={classes.attachmentIconBtn}
                        disabled={loading}
                        variant="contained"
                        component="label"
                      >
                        <input
                          onChange={handleFileInputChange}
                          type="file"
                          hidden
                          accept={ACCEPTED_IMAGE_FORMATS.join(",")}
                        />

                        <AttachmentIcon />
                      </IconButton>
                    </Tooltip>
                  </Badge>

                  {supportImage.selectedImage && (
                    <div className={classes.attachmentImgWrap}>
                      {/* <img
                              height="30"
                              width="30"
                              alt=""
                              src={makeAvatarUrl()}
                            /> */}
                      {/* className={classes.selectedImgName} */}
                      <span style={{ padding: "5px" }}>
                        {" "}
                        {supportImage.selectedImageName}{" "}
                      </span>
                      <Button
                        className={classes.cancelBtn}
                        onClick={resetSelectedImage}
                      >
                        X
                      </Button>{" "}
                    </div>
                  )}
                </Grid>
              )
            }}
          />
          <p className={classes.messageDetails}>
            <Trans components={{ b: <b /> }}>
              {t("SUPPORT_MODAL.TITLE_DISCRIPTION")}
            </Trans>
          </p>
        </Grid>
        <Grid className={classes.submitBtnWrap}>
          <Button
            onClick={messageSentSuccess}
            className={classes.sendPrimary}
            variant="contained"
            color="secondary"
            disabled={loading}
          >
            {loading ? (
              <CircularProgress className={classes.msgLoader} size="1.5rem" />
            ) : (
              <span>{t("SUPPORT_MODAL.SEND")}</span>
            )}
          </Button>
        </Grid>
      </Grid>
    </>
  );
};

export default CreatNew;
